// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../share/config';
import loading from '../../../share/components/vue/ProcessingIcon';

export default {
  name: "soldInformationMain",
  data() {
    return {
      processing: false,
      vin: '',
      specMode: '',
      spec: '',
      model: '',
      modelDisplayName: '',
      appliedModel: '',
    };
  },

  components: {
    'processing-view': loading,
  },

  methods: {
    ...mapActions('cache', ['cacheSystemTable', 'cacheSystemTree']),
    ...mapActions('table', ['clearTableData']),

    // FW2起動時の完全ログアウト処理実行
    tapLogout() {
      // App.js の完全ログアウト処理を呼び出し
      this.$emit('tapLogout', false);
    },
  },

  computed: {
    ...mapState({
      vehicleInfo: state => state.cache.vehicleInfo,
    }),
  },

  async created() {
    // メンバ変数に値を格納
    const vcl = this.vehicleInfo.vehicle;
    this.specMode = vcl.vin.type === 'vin' ? 'abroad' : 'domestic';
    this.vin = vcl.vin.vin;
    switch (vcl.vin.type) {
      case config.VEHICLEINFO_TYPE_VIN:
        this.spec = vcl.spec.model_year ? vcl.spec.model_year : '-';
        break;
      case config.VEHICLEINFO_TYPE_CHASSISNUMBER:
        this.spec = vcl.spec.classification ? vcl.spec.classification : '-';
        break;
      case config.VEHICLEINFO_TYPE_UN_KNOWN:
        this.spec = '-'; break;
      default:
        this.spec = '-'; break;
    }
    this.appliedModel = (vcl.vin.type === config.VEHICLEINFO_TYPE_CHASSISNUMBER && vcl.vin.applied_model) ? vcl.vin.applied_model : '-';
    this.model = vcl.spec.model || null;
    this.modelDisplayName = this.model || '-';
  },
};
